import InfoPage from '@/components/InfoPage';
import { Mail, Phone, Clock } from 'lucide-react';

const CentralAjuda = () => {
  return (
    <InfoPage title="Central de Ajuda">
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#302681' }}>Como Podemos Ajudar?</h2>
          <p className="text-gray-700 mb-6">
            Nossa equipe está sempre pronta para ajudar você. Entre em contato conosco através dos canais abaixo:
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-blue-50 p-6 rounded-lg">
              <Mail className="w-8 h-8 mb-3" style={{ color: '#302681' }} />
              <h3 className="font-semibold mb-2">Email</h3>
              <p className="text-sm text-gray-600">contato@parkingspot.com.br</p>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-lg">
              <Phone className="w-8 h-8 mb-3" style={{ color: '#302681' }} />
              <h3 className="font-semibold mb-2">Telefone</h3>
              <p className="text-sm text-gray-600">(11) 94525-2702</p>
            </div>

            <div className="bg-blue-50 p-6 rounded-lg">
              <Clock className="w-8 h-8 mb-3" style={{ color: '#302681' }} />
              <h3 className="font-semibold mb-2">Horário</h3>
              <p className="text-sm text-gray-600">24h por dia, 7 dias por semana</p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#831D1C' }}>Dúvidas Frequentes</h2>
          <p className="text-gray-700">
            Visite nossa página de <a href="/faq" className="text-[#302681] hover:underline font-semibold">FAQ</a> para encontrar respostas rápidas para as perguntas mais comuns.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#009440' }}>Suporte Técnico</h2>
          <p className="text-gray-700">
            Está tendo problemas técnicos? Descreva seu problema em detalhes e nossa equipe técnica entrará em contato o mais rápido possível.
          </p>
        </section>
      </div>
    </InfoPage>
  );
};

export default CentralAjuda;
